import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { browserHistory } from 'react-router';
import { Col, Row } from 'react-bootstrap';
import Select from 'react-select';
import SchemesImportModal from '../SchemesImportModal/SchemesImportModal';
import { ICON_MAP } from '../../../../common/components/SvgIcons/productIcons';
import { Button } from '../../../../common/components/Button/Button';

const ProductListItem = ({
  productId,
  productName,
  productCode,
  productDescription,
  buttons,
}) => {
  const [showUploadSchemesModal, setShowUploadSchemesModal] = useState(false);
  const buttonLabels = Object.keys(buttons);

  const MappedIcon = () => ICON_MAP[productCode];

  return (
    <Row className="product">
      <Col xs={12} className={'name-container'}>
        <MappedIcon />
        <h3 className={'name'}>{productName}</h3>
      </Col>
      <Col xs={12} className={'description d-none'}>
        <ReactMarkdown source={productDescription} />
      </Col>
      {showUploadSchemesModal ? (
        <Col xs={12} className={'call-to-action-container'}>
          <Row>
            <Col xs={12}>
              <SchemesImportModal />
            </Col>
            <Col xs={12} className="spacer" />
            <Col xs={12}>
              <Button
                label="Cancel import"
                bsStyle="default"
                className="btn-action"
                handleClick={() => setShowUploadSchemesModal(false)}
              />
            </Col>
          </Row>
        </Col>
      ) : (
        <Col xs={12} className={'call-to-action-container'}>
          <div className={'call-to-action-container--select'}>
            <Select
              onChange={(selected) => {
                if (selected.label === 'Import Schemes') {
                  setShowUploadSchemesModal(true);
                  return;
                }
                browserHistory.push(selected.value);
              }}
              options={buttonLabels.map((label) => {
                const buttonInfo = buttons[label];
                if (buttonInfo.type !== 'link') {
                  return {
                    label: label,
                    value: '',
                  };
                }
                return {
                  label: label,
                  value: `/admin/products/${productId}/${buttonInfo.url}`,
                };
              })}
              placeholder="Please select..."
              clearable={true}
            />
          </div>
        </Col>
      )}
    </Row>
  );
};

export default ProductListItem;
